import React from "react";
import styled, { DefaultTheme } from "styled-components";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import GoogleQR from "../../../assets/images/GoogleQR.jpg";
import gplay from "../../../assets/images/gplay.png";
import itunes from "../../../assets/images/itunes.png";
import AppleQR from "../../../assets/images/AppleQR.jpg";
import {
  faFacebookSquare,
  faPinterestSquare,
  faTwitterSquare,
  faInstagramSquare,
  faYoutubeSquare,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector } from "react-redux";
import { RootState } from "../../../app/store";

declare module "styled-components" {
  export interface DefaultTheme {
    palette: {
      header: {
        backgroundcolor: string;
        textcolor: string;
        button: {
          buttonBackground: string;
          background: string;
          buttonHoverBackground: string;
          buttonHoverColor: string;
        };
      };
      navbar: {
        backgroundcolor: string;
        textcolor: string;
      };
      message: {
        backgroundcolor: string;
        textcolor: string;
      };
      errormessage: {
        backgroundcolor: string;
        textcolor: string;
      };
      warningmessage: {
        backgroundcolor: string;
        textcolor: string;
      };
      linktext?: {
        color: string;
        hovercolor: string;
      };
      body: {
        backgroundcolor: string;
        textcolor: string;
      };
      button: {
        primary: {
          buttonBackground: string;
          background: string;
          buttonHoverBackground: string;
          buttonHoverColor: string;
          buttonBorder: string;
          buttonBoxshadow: string;
          buttonHoverBorder: string;
          buttonBoxHoverShadow: string;
        };
        secondary: {
          buttonBackground: string;
          background: string;
          buttonHoverBackground: string;
          buttonHoverColor: string;
        };
      };
      card: {
        backgroundcolor: string;
        textcolor: string;
      };
      subfooter: {
        backgroundcolor: string;
        textcolor: string;
      };
      footer: {
        backgroundcolor: string;
        textcolor: {
          primary: {
            textcolor: string;
          };
          secondary: {
            textcolor: string;
          };
        };
      };
    };
    typography?: {
      fontFamily: string;
    };
  }
}

// Define styled components
const StyledFooter = styled.div`
  background-color: ${(props) => props.theme.palette.footer?.backgroundcolor};
`;

const StyledLink = styled.a`
  color: ${(props) => props.theme.palette.footer?.textcolor.primary.textcolor};
`;

const StyledApp = styled.div`
  color: ${(props) => props.theme.palette.footer?.textcolor.primary.textcolor};
`;

const StyledSecondaryText = styled.span`
  color: ${(props) =>
    props.theme.palette.footer?.textcolor.secondary.textcolor} !important;
`;

const StyledFontAwesomeIcon = styled(FontAwesomeIcon)(({ theme }) => ({
  color: theme.palette.footer?.textcolor.primary.textcolor,
}));

const Footer = () => {
  const directionIsRTL = useSelector(
    (state: RootState) => state.theme.themeOptions?.direction === "rtl"
  );

  return (
    <StyledFooter>
      <Container>
        <Row className="d-flex justify-content-center py-3">
          <Col md={1} className="d-flex justify-content-center px-0">
            <StyledLink>Home</StyledLink>
          </Col>
          <Col md={1} className="d-flex justify-content-center px-0">
            <StyledLink>Career</StyledLink>
          </Col>
          <Col md={1} className="d-flex justify-content-center px-0">
            <StyledLink>Terms of use</StyledLink>
          </Col>
          <Col
            md={2}
            className="d-flex justify-content-center text-center px-0"
          >
            <StyledLink>Cancellation Policy</StyledLink>
          </Col>
          <Col md={1} className="d-flex justify-content-center px-0">
            <StyledLink>Privacy</StyledLink>
          </Col>
          <Col md={1} className="d-flex justify-content-center px-0">
            <StyledLink>Contact</StyledLink>
          </Col>
        </Row>
        <Row className="d-flex justify-content-center py-3">
          <Col md={4} className="">
            <Row>
              <Col className="p-1 d-flex justify-content-center">
                <StyledApp>Get your lounge booking app</StyledApp>
              </Col>
            </Row>
            <Row>
              <Col className="d-flex justify-content-center ">
                <a>
                  <img
                    src={gplay}
                    width="150"
                    className="d-inline-block p-1 align-center"
                    alt="Google Play"
                  />
                </a>
                <a>
                  <img
                    src={itunes}
                    width="150"
                    className="d-inline-block p-1 align-center"
                    alt="App Store"
                  />
                </a>
              </Col>
            </Row>
            <Row>
              <Col className="p-1 d-flex justify-content-center ">
                <img
                  src={GoogleQR}
                  width="150"
                  className="d-inline-block p-1 align-center"
                  alt=""
                />
                <img
                  src={AppleQR}
                  width="150"
                  className="d-inline-block p-1 align-center"
                  alt=""
                />
              </Col>
            </Row>
          </Col>
          <Col md={4} className="">
            <Row>
              <Col className="p-1 d-flex justify-content-center">
                <StyledApp>
                  Download the app for guide to explore Jamaica
                </StyledApp>
              </Col>
            </Row>
            <Row>
              <Col className="d-flex justify-content-center px-0">
                <a>
                  <img
                    src={gplay}
                    width="150"
                    className="d-inline-block p-1 align-center"
                    alt="Google Play"
                  />
                </a>
                <a>
                  <img
                    src={itunes}
                    width="150"
                    className="d-inline-block p-1 align-center"
                    alt="App Store"
                  />
                </a>
              </Col>
            </Row>
            <Row className="">
              <Col className="p-1 d-flex justify-content-center">
                <ul className="list-unstyled d-flex justify-centent-around px-0">
                  <li>
                    <a>
                      <StyledFontAwesomeIcon
                        icon={faFacebookSquare}
                        size={"2xl"}
                        className="primarytextColor font"
                        style={{
                          padding: "2px",
                        }}
                      />
                    </a>
                  </li>
                  <li>
                    <a>
                      <StyledFontAwesomeIcon
                        icon={faTwitterSquare}
                        size={"2xl"}
                        className="primarytextColor font"
                        style={{
                          padding: "2px",
                        }}
                      />
                    </a>
                  </li>
                  <li>
                    <a>
                      <StyledFontAwesomeIcon
                        icon={faPinterestSquare}
                        size={"2xl"}
                        className="primarytextColor font"
                        style={{
                          padding: "2px",
                        }}
                      />
                    </a>
                  </li>
                  <li>
                    <a>
                      <StyledFontAwesomeIcon
                        icon={faInstagramSquare}
                        size={"2xl"}
                        className="primarytextColor font"
                        style={{
                          padding: "2px",
                        }}
                      />
                    </a>
                  </li>
                  <li>
                    <a>
                      <StyledFontAwesomeIcon
                        icon={faYoutubeSquare}
                        size={"2xl"}
                        className=""
                        style={{
                          padding: "2px",
                        }}
                      />
                    </a>
                  </li>
                </ul>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col className="mb-3 d-flex custom-opacity justify-content-center ">
            <StyledSecondaryText>
              &copy; {new Date().getFullYear()} Club Mobay All rights reserved
            </StyledSecondaryText>
          </Col>
        </Row>
      </Container>
    </StyledFooter>
  );
};

export default Footer;
